import { API } from '@utils/axios'
import { appendParams } from '@utils/func'
import { IAPI } from 'AppTypes'

class ChargeManagementAPI implements IAPI {
  prefix = '/RevenueManagement';

  fetchRevenueListByMonth (params: TChargeManagementAPI.Params.ListByMonth) {
    const url = appendParams(`${this.prefix}/ListByMonth`, params)
    return API.get<TChargeManagementDetail.State['listByMonth']>(url)
  }

  fetchRevenueListByLiver (params: TChargeManagementAPI.Params.ListByLiver) {
    const url = appendParams(`${this.prefix}/ListWithDraw`, params)
    return API.get<TChargeManagementDetail.State['listByLiver']>(url)
  }

  fetchGmbCharges (params: TChargeManagementAPI.Params.ListGmbCharge) {
    const url = appendParams('StoreChargeManagement/GetGMBChargeList', params)
    return API.get<TChargeManagementDetail.State['listGMBCharge']>(url)
  }

  uploadExcel (file: FormData) {
    return API.post(`${this.prefix}/UploadApproveFileWithdraw`, file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  getUrlDownloadRevenueListByMonth (params: TChargeManagementAPI.Params.DownLoadByMonth) {
    return appendParams(`${API.defaults.baseURL}${this.prefix}/DowloadFileByMonth`, params)
  }

  async downloadRevenueListByMonth (params: TChargeManagementAPI.Params.DownLoadByMonth) {
    const url = this.getUrlDownloadRevenueListByMonth(params)
    const response = await API.get(url, { responseType: 'blob' })
    return response.data
  }

  async approveWithdrawal (data: any) {
    const response = await API.post(`${API.defaults.baseURL}${this.prefix}/ApproveWithdrawal`, data)
    return response.data
  }

  getUrlDownloadRevenueListByLiver (params: TChargeManagementAPI.Params.DownLoadByLiver) {
    return appendParams(`${API.defaults.baseURL}${this.prefix}/DowloadFileWithDraw`, params)
  }

  async downloadRevenueListByLiver (params: TChargeManagementAPI.Params.DownLoadByLiver) {
    const url = this.getUrlDownloadRevenueListByLiver(params)
    const response = await API.get(url, { responseType: 'blob' })
    return response.data
  }

  getUrlUploadRevenueListByLiver () {
    return `${API.defaults.baseURL}${this.prefix}/UploadApproveFileWithdraw`
  }

  async uploadRevenuListByLiver (data: any) {
    const response = await API.post(this.getUrlUploadRevenueListByLiver(), data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      responseType: 'blob'
    })

    return response.data
  }
}

export const chargeManagementApi = new ChargeManagementAPI()
